import { Icon } from "@iconify/react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";

import Badge from "@mui/material/Badge";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { logoutChannel } from "../auth/broadcastSetup";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
import { Logout } from "@mui/icons-material";

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { profileData } = useSelector((state) => state.profile);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogOut = () => {
    const token = getAccesstoken();
    axios
      .get(`${base_url}/digilocker/LogOut`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.message === "Logged Out Successfully") {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("email");
          sessionStorage.removeItem("access");
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("refresh");
          Object.keys(sessionStorage)
            .filter((key) => key.startsWith("digilocker_"))
            .forEach((key) => sessionStorage.removeItem(key));
          window.location.replace("/login");
          logoutChannel.postMessage("logout");
        }
      });
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    return words.length > 1
      ? `${words[0][0]}${words[1][0]}`.toUpperCase()
      : `${words[0][0]}`.toUpperCase();
  };

  return (
    <Wrapper style={{ display: "flex", alignItems: "center", gap: "15px" }}>
      {/* <Box
        sx={{
          height: 40,
          backgroundColor: "var(--dl-warning-soft)",
          display: "flex",
          alignItems: "center",
          gap: 1,
          padding: "0 12px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
        onClick={() => {
          navigate("/dashboard");
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/credit.png`}
          alt="Credit"
          style={{ width: 21, height: 21 }}
        />
        <Typography
          sx={{ fontWeight: 500, fontSize: "16px", color: "#000000" }}
        >
          {allData || 0} Credits
        </Typography>
      </Box> */}
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0.55,
          pr: { xs: 0.55, sm: 1 },
          borderRadius: "11px",
          border: "1px solid transparent",
          "&:hover": {
            bgcolor: "var(--dl-surface-soft)",
            borderColor: "var(--dl-border)",
          },
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
            },
          }),
        }}
      >
        <Stack
          direction={"row"}
          spacing={0.9}
          alignItems={"center"}
          justifyContent={"start"}
        >
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
          >
            <Avatar
              sx={{
                width: 36,
                height: 36,
                bgcolor: "var(--dl-success-soft)",
                color: "success.main",
                fontWeight: "bold",
                fontSize: 13,
              }}
              alt={profileData?.company_name || ""}
              src={profileData?.logo || ""}
              onError={(e) => (e.target.src = "")}
            >
              {getInitials(profileData?.company_name)}
            </Avatar>
          </StyledBadge>
          <Stack
            alignItems={"start"}
            sx={{
              color: "var(--dl-text)",
              flexDirection: "row",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: { xs: "none", sm: "block" }, textAlign: "left" }}>
              <Typography
                color="var(--dl-text)"
                fontSize={12}
                fontWeight={750}
                lineHeight={1.25}
                noWrap
                sx={{ maxWidth: 190 }}
              >
                {profileData.company_name || "Administrator"}
              </Typography>
              <Typography color="var(--dl-text-faint)" fontSize={9.5} lineHeight={1.3}>
                Admin account
              </Typography>
            </Box>
            <Stack
              alignItems={"center"}
              direction="row"
              sx={{ color: "var(--dl-text-muted)" }}
            >
              <Icon icon="material-symbols:arrow-drop-down" />
            </Stack>
          </Stack>
        </Stack>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            width: 250,
            borderRadius: "12px",
            border: "1px solid var(--dl-border)",
            boxShadow: "0 18px 45px rgba(15,23,42,.14)",
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ py: 1.75, px: 2 }}>
          <Typography color="var(--dl-text)" fontSize={12.5} fontWeight={750} noWrap>
            {profileData.company_name || "Administrator"}
          </Typography>
          <Typography color="var(--dl-text-faint)" fontSize={10.5} noWrap mt={0.3}>
            {profileData.company_email}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: "dashed" }} />
        {/* <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="body2" noWrap>
            Secret token :{" " + profileData.username}
          </Typography>
        </Box> */}

        {/* <Divider sx={{ borderStyle: "dashed" }} />
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="body2" noWrap>
            Negative Index :{" " + profileData.isNegativeRunning}
          </Typography>
        </Box> */}

        <MenuItem
          onClick={handleLogOut}
          sx={{
            m: 0.8,
            px: 1.25,
            py: 0.9,
            display: "flex",
            justifyContent: "flex-start",
            gap: 1,
            color: "#b42318",
            bgcolor: "var(--dl-surface)",
            "&:hover": { bgcolor: "var(--dl-danger-soft)" },
          }}
        >
          <Logout sx={{ fontSize: 18 }} />
          <span>Logout</span>
        </MenuItem>
      </Popover>
    </Wrapper>
  );
}

const StyledBadge = muiStyled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const Wrapper = styled.div`
  .MuiAvatar-img {
    height: fit-content;
  }
`;
